import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { updateApplyAction } from 'app-components/flux/transaction-rules/transactionRuleActions';
import { useStateContext } from 'app-components/flux/transaction-rules/transactionRulesFormState';
import type { TransactionRuleType } from 'app-components/flux/transaction-rules/transactionRulesTypes';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { useAppSelector } from 'hooks/redux';
import useStyles from './styles';

const RuleApplication = ({ rule, sinceDate }: { rule: TransactionRuleType; sinceDate?: string }) => {
  const { cx, classes } = useStyles();
  const { dispatch } = useStateContext();

  const rulePreviewEnabled = useAppSelector((state) =>
    featureFlagsSelectors.getFeatureFlag(state, 'enableRenamePreview'),
  );

  const applyToolTipText =
    'This rule won’t be applied to existing transfers to keep them linked correctly. This includes credit card payments, balance adjustments, and opening balances.';

  const sinceText = sinceDate ? `since ${sinceDate}` : undefined;

  return (
    <Box className={cx(classes.ruleApplicationHeader, !rulePreviewEnabled && classes.noPreviewRules)}>
      <Box className={classes.row}>
        <Checkbox
          id='apply-rule-to-existing'
          sx={{ padding: '4px' }}
          checked={!!rule?.applyToExistingTransactions}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(updateApplyAction(!!event.target.checked));
          }}
        />
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', pl: 0.5 }}>
          <Typography
            className={cx(rule?.applyToExistingTransactions ? classes.highlightText : '')}
            variant='bodyMedium'
          >
            Apply rule to existing transactions
          </Typography>
          <Tooltip
            arrow
            placement='right'
            title={applyToolTipText}
            slotProps={{
              tooltip: {
                sx: {
                  maxWidth: 420,
                  padding: 2,
                },
              },
            }}
          >
            <InfoIcon className={classes.infoIcon18} />
          </Tooltip>
        </Box>
      </Box>
      {rulePreviewEnabled && (
        <Box className={classes.sinceText}>
          <Typography variant='bodyRegular'>Sample matches</Typography>
          {sinceText && <Typography variant='captionRegular'>{sinceText}</Typography>}
        </Box>
      )}
    </Box>
  );
};

export default RuleApplication;
